// src/components/PurchaseFlow/Steps/ConfirmationViews/DefaultConfirmationView.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatCurrency } from '../../../../utils/numberFormatter';
import { 
  faFileSignature,
  faCalculator,
  faDollarSign,
  faCalendar,
  faPercentage,
  faHandHoldingUsd,
  faCalendarCheck,
  faExclamationTriangle,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

const DefaultConfirmationView = ({ 
  selectedOffer, 
  isProcessing, 
  onConfirmButtonClick 
}) => {
  return (
    <div className="container my-5">
      <h2 className="text-center mb-2">
        <FontAwesomeIcon icon={faFileSignature} className="me-2" />
        Confirmación de Préstamo
      </h2>
      <p className="text-center mb-4 text-muted">Revisa los detalles antes de confirmar la operación.</p>

      <hr className="my-4" />

      <div className="row justify-content-center m-2">
        <div className="summary-section">
            <h2>
                <FontAwesomeIcon icon={faCalculator} />
                Resumen del Crédito
            </h2>

            <div className="summary-item">
                <div className="summary-label">
                    <FontAwesomeIcon icon={faDollarSign} />
                    Monto Solicitado
                </div>
                <div className="summary-value">{formatCurrency(selectedOffer.originalAmount, 2)}</div>
            </div>

            {selectedOffer.isDownpaymentPlan && (
              <>
                <div className="summary-item">
                    <div className="summary-label">
                        <FontAwesomeIcon icon={faDollarSign} />
                        Anticipo
                    </div>
                    <div className="summary-value">{formatCurrency(selectedOffer.downpaymentAmount, 2)} {selectedOffer.downpaymentType === 'percentage' ? `(${selectedOffer.downpaymentValue}% del capital)` : `(equivalente a ${selectedOffer.downpaymentValue} cuota${selectedOffer.downpaymentValue > 1 ? 's' : ''})`}</div>
                </div>

                <div className="summary-item">
                    <div className="summary-label">
                        <FontAwesomeIcon icon={faDollarSign} />
                        Monto a Financiar
                    </div>
                    <div className="summary-value">{formatCurrency(selectedOffer.amount, 2)}</div>
                </div>
              </>
            )}

            <div className="summary-item">
                <div className="summary-label">
                    <FontAwesomeIcon icon={faCalendar} />
                    Cuotas
                </div>
                <div className="summary-value">{selectedOffer.term} cuotas de {formatCurrency(selectedOffer.monthlyPayment,2)}</div>
            </div>
            <div className="summary-item">
                <div className="summary-label">
                    <FontAwesomeIcon icon={faPercentage} />
                    TNA (Tasa Nominal Anual)
                </div>
                <div className="summary-value">
                  {(selectedOffer.interestRate * 100).toFixed(2)}%
                </div>
            </div>

            <div className="summary-item">
                <div className="summary-label">
                    <FontAwesomeIcon icon={faCalendar} />
                    Primer vencimiento
                </div>
                <div className="summary-value">{selectedOffer.displayDate}</div>
            </div>
        </div>
      </div>

      <div className="row justify-content-center m-2">
        <div className="terms-section">
            <div className="terms-item">
                <div className="terms-icon text-primary">
                    <FontAwesomeIcon icon={faHandHoldingUsd} />
                </div>
                <div>
                    <h6 className="mb-1 mt-1">Métodos de Cobro</h6>
                    <p className="mb-0"> - Débito automático en tarjeta o cuenta bancaria.</p>
                    <p className="mb-0"> - Débito interno o DEBIN Spot si está habilitado.</p>
                    <p className="mb-0"> - Transferencia bancaria o pago en el domicilio de la financiera.</p>
                </div>
            </div>

            <div className="terms-item">
                <div className="terms-icon text-primary">
                    <FontAwesomeIcon icon={faCalendarCheck} />
                </div>
                <div>
                <h6 className="mb-1 mt-1">Pago Anticipado</h6>
                    <p>Puede cancelar anticipadamente sin penalización.</p>
                </div>
            </div>
            <div className="terms-item">
                <div className="terms-icon text-primary">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
                <div>
                  <h6 className="mb-1 mt-1">Penalización por Mora</h6>
                  <p>Interés punitorio del 50% sobre la tasa vigente.</p>
                </div>
            </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <button 
          className="btn btn-primary btn-lg" 
          onClick={onConfirmButtonClick}
          disabled={isProcessing}
        >
          {isProcessing ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Procesando...
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
              {selectedOffer?.isDownpaymentPlan ? 'Realizar Pago Inicial y Confirmar' : 'Confirmar y Generar Préstamo'}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default DefaultConfirmationView;
